var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"credentials-settings"},[_c('div',{staticClass:"household-name-container"},[_c('div',{staticClass:"title"},[_vm._v("היי "+_vm._s(_vm.householdName))])]),_vm._v(" "),_c('div',{staticClass:"credentials-list-container"},[_c('credentials-list')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1116cc92","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/responsive-pages/authenticated/navigation-pages/credentials-settings/CredentialsSettings.vue
// module id = null
// module chunks = 